import React from 'react';
import { useTranslation } from 'react-i18next';

const COLORS = {
  primary: 'bg-primary-50 text-primary-700 hover:bg-primary-100',
  green: 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100',
  yellow: 'bg-amber-50 text-amber-700 hover:bg-amber-100',
  purple: 'bg-purple-50 text-purple-700 hover:bg-purple-100',
  orange: 'bg-orange-50 text-orange-700 hover:bg-orange-100',
  red: 'bg-red-50 text-red-700 hover:bg-red-100',
  gray: 'bg-gray-50 text-gray-700 hover:bg-gray-100',
};

/** The single action-button-grid style, shared by every dashboard instead
 * of each one styling its own — `actions` is [{ label, icon, color, onClick }]. */
export default function QuickActions({ actions, columns = 1 }) {
  const { t } = useTranslation();
  const gridCols = columns === 2 ? 'sm:grid-cols-2' : '';
  return (
    <div className="bg-white rounded-2xl shadow-card p-4">
      <h3 className="text-sm font-display font-bold text-gray-800 mb-3">{t('Quick Actions')}</h3>
      <div className={`grid grid-cols-1 ${gridCols} gap-2`}>
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={action.onClick}
            className={`w-full flex items-center px-3 py-2.5 rounded-xl transition text-sm font-medium ${COLORS[action.color] || COLORS.primary}`}
          >
            {action.icon && <span className="w-4 h-4 mr-2.5 shrink-0">{action.icon}</span>}
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
}
